import styled from 'styled-components'

import { COLORS } from '@treelab/panda'

export const Container = styled.div`
  padding-top: 16px;
`;

export const MessageContainer = styled.div`
  padding: 12px;
  display: flex;
  justify-content: center;
  background-color: ${COLORS.yellowMask};
  border-radius: 8px;

  & > *:first-child {
    margin-top: 4px;
    flex-shrink: 0;
    color: ${COLORS.yellow};
  }

  & > *:last-child {
    color: ${COLORS.greyDark1};
    font-size: 14px;
    line-height: 24px;
    margin-left: 8px;
  }
` 

export const PlaceholderContainer = styled.div`
  margin-top: 16px;
`

export const PlaceholderVertical = styled.div`
  display: inline-block;
  background-color: ${COLORS.greyLight5};
  width: 3px;
  height: 14px;
  border-radius: 2px;
`

export const PlaceholderTitle = styled.div`
  margin-left: 16px;
  display: inline-block;
  width: 64px;
  height: 14px;
  border-radius: 4px;
  background-color: ${COLORS.greyLight5};
`

export const PlaceholderMessage = styled.div`
  margin-top: 11px;
  margin-left: 16px;
  height: 32px;
  border-radius: 4px;
  background-color: ${COLORS.greyLight5};
`
